import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { DisclaimerBanner } from './DisclaimerBanner';

const disclaimerBannerAddon = AddonBlueprint.make({
  name: 'disclaimer-banner',
  params: {
    name: 'TechDocsDisclaimerBanner',
    location: TechDocsAddonLocations.Subheader,
    component: DisclaimerBanner,
  },
});

export default createFrontendModule({
  pluginId: 'techdocs',
  extensions: [disclaimerBannerAddon],
});
